import React from "react";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Barcode from "./pages/Barcode";
import Calendar from "./pages/Calendar";
import Vass from "./pages/Vass";
import Nvr from "./pages/Nvr";
import NvrRun from "./pages/NvrRun";
import Edit from "./pages/Edit";
import AddBarcode from "./pages/AddBarcode";
import ChangePassword from "./pages/ChangePassword";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import GlobalStyles from "./css/GlobalStyles.js"; // Import your global styles
import { isBlackUIViewState } from "./stores/isBlackUIViewState";
import { useRecoilValue } from "recoil";
import { ThemeProvider } from "styled-components";
import { colorWhite, colorDark } from "./css/palette.js";

function App() {
  const isBlackUI = useRecoilValue(isBlackUIViewState);
  const theme = isBlackUI ? colorDark : colorWhite;
  document.title = "Vass";
  return (
    <div>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <GlobalStyles />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/Dashboard" element={<Dashboard theme={theme} />} />
            <Route path="/Barcode" element={<Barcode theme={theme} />} />
            <Route path="/AddBarcode" element={<AddBarcode theme={theme} />} />
            <Route path="/Edit" element={<Edit theme={theme} />} />
            <Route path="/Calendar" element={<Calendar theme={theme} />} />
            <Route path="/Vass" element={<Vass theme={theme} />} />
            <Route path="/Nvr" element={<Nvr theme={theme} />} />
            <Route path="/NvrRun" element={<NvrRun theme={theme} />} />
            <Route path="/ChangePassword" element={<ChangePassword />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
